<div mat-dialog-title>
  <mat-icon class="title align-middle">business</mat-icon>{{ dialogTitle | translate: locale.language }}
</div>
<div mat-dialog-content>
  @if (facility) {
    @if (facility.name) {
      <div id="facility-name" class="row-item">
        <span class="summary-label"><mat-icon>business</mat-icon>{{ 'Name' | translate: locale.language }}:</span>
        <div>{{ facility.name }}</div>
      </div>
    }
    @if (facility.typeAttr?.value) {
      <div id="facility-type" class="row-item">
        <span class="summary-label"
          ><mat-icon>info_outline</mat-icon>{{ facility.typeAttr?.name ?? 'Type' | translate: locale.language }}:</span
        >
        <div>{{ facility.typeAttr?.value }}</div>
      </div>
    }
    @if (facility.brandAttr?.value) {
      <div id="facility-brand" class="row-item">
        <span class="summary-label"
          ><mat-icon>info_outline</mat-icon
          >{{ facility.brandAttr?.name ?? 'Brand' | translate: locale.language }}:</span
        >
        <div>{{ facility.brandAttr?.value }}</div>
      </div>
    }
    @if (facility.brandGroupsAttr?.value) {
      <div id="facility-brand-groups" class="row-item">
        <span class="summary-label"
          ><mat-icon>info_outline</mat-icon
          >{{ facility.brandGroupsAttr?.name ?? 'Brand Groups' | translate: locale.language }}:</span
        >
        <div>{{ facility.brandGroupsAttr?.value }}</div>
      </div>
    }
    @if (facility.phoneNumber) {
      <div id="facility-phone" class="row-item">
        <span class="summary-label"><mat-icon>local_phone</mat-icon>{{ 'Phone' | translate: locale.language }}:</span>
        <div>
          <a href="{{ 'tel:' + facility.phoneNumber | phone }}" target="_blank" rel="noopener"
            >{{ facility.phoneNumber | phone }}
            <span class="popup"><mat-icon>open_in_new</mat-icon></span>
          </a>
        </div>
      </div>
    }
    @if (addressQuery && addressParts?.length) {
      <div id="facility-address" class="row-item">
        <span class="summary-label"
          ><mat-icon>location_on</mat-icon>{{ 'Location' | translate: locale.language }}:</span
        >
        <div>
          <a href="{{ addressQuery }}" target="_blank" rel="noopener">
            @for (part of addressParts; track part; let i = $index) {
              <span
                >{{ part }}
                @if (i === 0) {
                  <span class="popup"><mat-icon>open_in_new</mat-icon></span>
                }
                <br />
              </span>
            }
          </a>
        </div>
      </div>
    }
    @if (facility.region) {
      <div id="facility-region" class="row-item">
        <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ 'Region' | translate: locale.language }}:</span>
        <div>{{ facility.region }}</div>
      </div>
    }
    @if (facility.areaAttr?.value) {
      <div id="facility-area" class="row-item">
        <span class="summary-label"
          ><mat-icon>info_outline</mat-icon>{{ facility.areaAttr?.name ?? 'Area' | translate: locale.language }}:</span
        >
        <div>{{ facility.areaAttr?.value }}</div>
      </div>
    }
    @if (facility.area) {
      <div id="facility-area" class="row-item">
        <span class="summary-label"><mat-icon>info_outline</mat-icon>{{ 'Area' | translate: locale.language }}:</span>
        <div>{{ facility.area }}</div>
      </div>
    }
    @if (facility.subAreaAttr?.value) {
      <div id="facility-sub-area" class="row-item">
        <span class="summary-label"
          ><mat-icon>info_outline</mat-icon
          >{{ facility.subAreaAttr?.name ?? 'Sub Area' | translate: locale.language }}:</span
        >
        <div>{{ facility.subAreaAttr?.value }}</div>
      </div>
    }
  } @else {
    <div class="row">
      <app-loading
        [hasFailed]="!!loadError"
        [failTitle]="loadError"
        [hideRetry]="hideRetry"
        (retryClicked)="loadAsset()"></app-loading>
    </div>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-button color="primary" id="closeFacility" mat-dialog-close="">
    {{ 'Close' | translate: locale.language }}
  </button>
</div>
